<template>
  <div class="col-auto">
    <label :for="id" class="col-form-label">削除状態</label>
  </div>
  <div class="col-auto">
    <select :id="id" class="form-select" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
      <option value="all">全て</option>
      <option value="active">削除されていないデータ</option>
      <option value="deleted">削除済みデータ</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: 'active'
    },
    id: {
      type: String,
      default: 'deletedStatus'
    }
  },
  emits: ['update:modelValue']
};
</script>
